import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

export const CTAFinal = () => {
  return (
    <section
      id="contato"
      data-testid="cta-final-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-[#3532B3] via-[#3787F5] to-[#12DDB5] p-10 md:p-16 lg:p-20 shadow-[0_30px_80px_rgba(53,50,179,0.35)]"
        >
          {/* Decorative shapes */}
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-white/10 blur-3xl" />
          <div className="absolute -bottom-40 -left-20 w-[400px] h-[400px] rounded-full bg-[#73F2B3]/30 blur-3xl" />
          <svg
            className="absolute top-8 right-8 opacity-20"
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
          >
            <circle cx="60" cy="60" r="58" stroke="white" strokeWidth="1.5" />
            <circle cx="60" cy="60" r="38" stroke="white" strokeWidth="1.5" />
            <circle cx="60" cy="60" r="18" stroke="white" strokeWidth="1.5" />
          </svg>

          <div className="relative grid lg:grid-cols-5 gap-10 items-center">
            <div className="lg:col-span-3">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-xs font-bold uppercase tracking-[0.18em] border border-white/20">
                Vamos conversar
              </span>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-white tracking-[-0.02em] leading-[1.1]">
                Parceira estratégica em gestão de risco para sua carteira
              </h2>
              <p className="mt-5 text-white/85 text-lg leading-relaxed max-w-2xl">
                Vamos desenhar a operação ideal para a sua realidade,
                combinando modelo, critérios, indicadores e inteligência
                técnica para decisões mais seguras.
              </p>
            </div>
            <div className="lg:col-span-2 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
              <a
                data-testid="cta-final-whatsapp"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white text-[#3532B3] font-bold shadow-[0_12px_30px_rgba(0,0,0,0.18)] hover:-translate-y-0.5 hover:shadow-[0_18px_38px_rgba(0,0,0,0.22)] transition-all duration-300"
              >
                <MessageCircle size={18} strokeWidth={2.2} />
                Falar com especialista
                <ArrowRight size={18} strokeWidth={2.2} />
              </a>
              <span className="text-white/80 text-sm">
                Atendimento via WhatsApp · Resposta rápida
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
